/**
 * Asks for confirmation before submitting a destructive form.
 *
 * Usage: <form method="post" data-confirm-message="Delete everything?">
 */

import { showDeleteConfirm } from '../dom/confirmModal';

type Confirm = (message: string) => Promise<boolean>;

export function initConfirmSubmit(confirm: Confirm = showDeleteConfirm): void {
  document.querySelectorAll<HTMLFormElement>('form[data-confirm-message]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      void confirm(form.dataset.confirmMessage ?? '').then((confirmed) => {
        if (confirmed) {
          form.submit();
        }
      });
    });
  });
}
